// extracted by mini-css-extract-plugin
module.exports = {"activeTab":"Tabber_activeTab__FhOvw"};